import { ReactNode } from 'react';

import {
  ExclamationMarkHexagonIcon,
  ThumbUpOutlineIcon,
  EcommExclamationMarkChatBubbleIcon,
  TrashIcon,
} from '@grupoboticario/flora-react-icons';

export const iconMap: { [key: string]: ReactNode } = {
  successPartialAddProduct: <ExclamationMarkHexagonIcon size="24" />,
  errorQuotaAddProduct: <ExclamationMarkHexagonIcon size="24" />,
  successAddProduct: <ThumbUpOutlineIcon size="24" />,
  errorAddProduct: <EcommExclamationMarkChatBubbleIcon size="24" />,
  successRemoveProduct: <TrashIcon size="24" />,
  errorRemoveProduct: <EcommExclamationMarkChatBubbleIcon size="24" />,
};
